import React from 'react';
import { Link } from 'react-router-dom';

const TermsOfService = () => {
  return (
    <div className="max-w-4xl mx-auto p-8">
      <h1 className="text-3xl font-bold mb-6 text-orpi-secondary">Conditions Générales d'Utilisation</h1>
      
      <p className="mb-4">Dernière mise à jour : {new Date().toLocaleDateString()}</p>
      
      <div className="space-y-6">
        <section>
          <h2 className="text-xl font-semibold mb-3 text-orpi-secondary">1. Introduction</h2>
          <p>
            Les présentes Conditions Générales d'Utilisation (CGU) régissent votre accès et utilisation 
            de notre site web et service de demande de crédit en ligne (ci-après le "Service"). 
            En accédant ou en utilisant notre Service, vous acceptez d'être lié par ces CGU.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-3 text-orpi-secondary">2. Description du service</h2>
          <p>
            Notre Service vous permet de simuler et de demander un crédit à la consommation en ligne.
            Les informations fournies sur le site sont uniquement à titre informatif et ne constituent 
            pas une offre contraignante. Une demande de crédit est soumise à l'étude et à l'acceptation 
            de notre établissement.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-3 text-orpi-secondary">3. Conditions d'utilisation</h2>
          <p>Pour utiliser notre Service, vous devez :</p>
          <ul className="list-disc ml-6 mt-2 space-y-1">
            <li>Être âgé d'au moins 18 ans</li>
            <li>Avoir la capacité juridique de contracter</li>
            <li>Résider en France métropolitaine</li>
            <li>Disposer d'un compte bancaire valide</li>
            <li>Fournir des informations exactes et à jour</li>
          </ul>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-3 text-orpi-secondary">4. Processus de demande de crédit</h2>
          <p>
            Le processus de demande de crédit se déroule en plusieurs étapes :
          </p>
          <ol className="list-decimal ml-6 mt-2 space-y-1">
            <li>Simulation des conditions de crédit</li>
            <li>Saisie des informations personnelles et financières</li>
            <li>Transmission des documents justificatifs</li>
            <li>Étude de votre dossier par nos équipes</li>
            <li>Décision finale de crédit et proposition contractuelle le cas échéant</li>
          </ol>
          <p className="mt-2">
            Une pré-acceptation en ligne ne constitue pas un accord définitif de crédit.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-3 text-orpi-secondary">5. Obligations de l'utilisateur</h2>
          <p>En utilisant notre Service, vous vous engagez à :</p>
          <ul className="list-disc ml-6 mt-2 space-y-1">
            <li>Fournir des informations exactes, complètes et à jour</li>
            <li>Ne pas utiliser le Service à des fins illégales ou non autorisées</li>
            <li>Ne pas tenter de compromettre la sécurité du Service</li>
            <li>Ne pas transmettre de virus, malwares ou autres codes malveillants</li>
            <li>Respecter les droits de propriété intellectuelle</li>
          </ul>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-3 text-orpi-secondary">6. Propriété intellectuelle</h2>
          <p>
            Le contenu du Service, y compris les textes, graphiques, logos, images, et logiciels, 
            est la propriété d'ORPI France et est protégé par les lois sur la propriété 
            intellectuelle. Vous n'êtes pas autorisé à reproduire, distribuer, modifier ou 
            exploiter ce contenu sans notre autorisation écrite préalable.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-3 text-orpi-secondary">7. Protection des données personnelles</h2>
          <p>
            La collecte et le traitement de vos données personnelles sont régis par notre 
            <Link to="/politique-confidentialite" className="text-orpi-primary hover:underline"> Politique de Confidentialité</Link>, 
            qui fait partie intégrante des présentes CGU.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-3 text-orpi-secondary">8. Limitation de responsabilité</h2>
          <p>
            ORPI France s'efforce de maintenir le Service accessible et à jour. Cependant, 
            nous ne pouvons garantir que le Service sera disponible en permanence ou exempt d'erreurs. 
            Le Service est fourni "tel quel" et "selon disponibilité", sans garantie d'aucune sorte.
          </p>
          <p className="mt-2">
            ORPI France ne sera pas responsable des dommages indirects, accessoires, spéciaux, 
            consécutifs ou punitifs, y compris la perte de profits, de données ou d'opportunités 
            commerciales, résultant de votre utilisation du Service.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-3 text-orpi-secondary">9. Modification des CGU</h2>
          <p>
            Nous nous réservons le droit de modifier ces CGU à tout moment. Les modifications 
            prendront effet dès leur publication sur le Service. Nous vous encourageons à consulter 
            régulièrement les CGU pour vous tenir informé des mises à jour.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-3 text-orpi-secondary">10. Droit applicable et juridiction compétente</h2>
          <p>
            Les présentes CGU sont régies par le droit français. Tout litige relatif à leur 
            interprétation ou à leur exécution relève, à défaut de résolution amiable, de la 
            compétence exclusive des tribunaux français.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-3 text-orpi-secondary">11. Dispositions finales</h2>
          <p>
            Si une disposition des présentes CGU est jugée illégale, nulle ou inapplicable, 
            les autres dispositions resteront en vigueur. Ces CGU constituent l'intégralité 
            de l'accord entre vous et ORPI France concernant le Service.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-3 text-orpi-secondary">12. Contact</h2>
          <p>
            Pour toute question concernant ces CGU, veuillez nous contacter à :
          </p>
          <p className="mt-2">
            ORPI France<br />
            [Adresse]<br />
            Email : contact@orpi.com<br />
            Téléphone : [téléphone]
          </p>
        </section>
      </div>
      
      <div className="mt-10">
        <Link to="/" className="text-orpi-primary hover:underline">Retour à l'accueil</Link>
      </div>
    </div>
  );
};

export default TermsOfService;